import { createSelector } from "@reduxjs/toolkit";

const defaultBanners = {
  items: [],
  loading: false,
  isPromocodeModalOpen: false
};

const defaultState = { banners: { ...defaultBanners }};

const getBanners = (state = defaultState) =>
  state.banners;

export const getBannersLoading = createSelector(
  [getBanners],
  ({loading}) => loading
);
export const getBannersSelector = createSelector(
  [getBanners],
  ({items}) => items
);

export const getIsPromocodeModalOpen = (state) => state.banners.isPromocodeModalOpen